import React, { useMemo } from 'react';
import DropDown from '../dropdown';
import PropTypes from 'prop-types';
import { RateCategory as RateCategories } from '../constants';
import { useTextResources } from '../../../language';
import { pickBy } from '../utils';

const RateCategoriesDropDown = ({ rateCategoryIds = [], ...props }) => {
  const text = useTextResources();

  //If provided with RateCategoriesIds, use only those. Otherwise, use the entire Enum
  const options = useMemo(() => {
    return rateCategoryIds.length
      ? pickBy(RateCategories, (key) => rateCategoryIds.includes(key))
      : RateCategories;
  }, [rateCategoryIds]);

  const data = useMemo(() => {
    return Object.entries(options).reduce((acc, [key, value]) => {
      acc.push({
        text: text(key),
        value,
      });
      return acc;
    }, []);
  }, [options]);

  return (
    <DropDown textField='text' valueField='value' data={data} {...props} />
  );
};

RateCategoriesDropDown.propTypes = {
  rateCategoryIds: PropTypes.array,
};

export default RateCategoriesDropDown;
